export const GA_EVENTS = {
    RADIO_BUTTON_CDP: {
        event: "ew_radio_button_selected",
        eventCategory: "ew_top_funnel"
    }
};
